import * as AbstractValidation from '../../../libs/validation/remoteValidationAbstract'
import * as Constants from '../../../costants'

export function namesValidation (
    value: string,
    koCallBack: Function
) {

    AbstractValidation.namesValidation(
        value,
        koCallBack
    )
}

export function companyValidation (
    value: string,
    koCallBack: Function
) { 
    AbstractValidation.objectsNamesValidation(
        value,
        koCallBack
    )
}

export function emailsValidation (
    value: string,
    koCallBack: Function
) {

    AbstractValidation.valueValidation(
        Constants.EMAIL_VALIDATION_URL,
        value,
        AbstractValidation.voidFunction,
        koCallBack
    )
}

export function phonesValidation (
    value: string,
    koCallBack: Function
) {

    AbstractValidation.valueValidation(
        Constants.PHONE_VALIDATION_URL,
        value,
        AbstractValidation.voidFunction,
        koCallBack
    )
}

export function pIvaValidation (
    value: string,
    koCallBack: Function
) {
    AbstractValidation.valueValidation(
        Constants.PIVA_VALIDATION_URL,
        value,
        AbstractValidation.voidFunction,
        koCallBack
    )
}

export function streetValidation (
    value: string,
    koCallBack: Function
) {
    AbstractValidation.valueValidation(
        Constants.STREET_VALIDATION_URL,
        value,
        AbstractValidation.voidFunction,
        koCallBack
    )
}